export const PersonInformData = [
  {
    name: 'jnj',
    text: `■ 개인정보 수집∙이용에 관한 사항\n수집∙이용 목적: 본 사이트 회원 가입 및 이용 (제품 주문 및 주문 진행 현황 확인)
    수집하려는 개인정보의 항목: 성명, 휴대폰 번호
    개인정보의 보유 및 이용 기간: 탈퇴 요청시 까지
    귀하는 동의를 거부하실 수 있으나, 동의를 거부하시는 경우 본 사이트 회원 가입 및 이용이 어렵습니다.`
  },
]
//PersonInformData.text.appendChild('<div>dd</div>')
